// Generated from ../platform-php/contracts/admin.openapi.yaml, ../platform-php/contracts/ai.openapi.yaml, ../platform-php/contracts/billing.openapi.yaml, ../platform-php/contracts/catalogue.openapi.yaml, ../platform-php/contracts/checkout.openapi.yaml, ../platform-php/contracts/delivery.openapi.yaml, ../platform-php/contracts/docs.openapi.yaml, ../platform-php/contracts/identity.openapi.yaml, ../platform-php/contracts/ledger.openapi.yaml, ../platform-php/contracts/payments.openapi.yaml, ../platform-php/contracts/pricing.openapi.yaml, ../platform-php/contracts/reporting.openapi.yaml, ../platform-php/contracts/risk.openapi.yaml, ../platform-php/contracts/webhooks.openapi.yaml by @bemor/web-kit scripts/generate-types.mjs. Do not edit.
// BM-46 §2.4: what each list endpoint allows (sorts, default order, date column, cursor paging, filters, export).

export const LISTS = {
    '/merchant/ai/calls': {
        path: '/merchant/ai/calls',
        sorts: [
            'created_at',
            'board',
            'surface',
            'actor_id',
            'input_tokens',
            'output_tokens',
            'cost_micros',
            'duration_ms',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            surface: {
                array: true,
                values: null,
            },
            subject_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, surface, subject or actor contains',
            },
        },
        export: null,
    },
    '/merchant/api-keys': {
        path: '/merchant/api-keys',
        sorts: ['created_at', 'last_used_at', 'revoked_at', 'name', 'mode'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            mode: {
                array: true,
                values: ['live', 'test'],
            },
            q: {
                array: false,
                values: null,
                description: 'name or prefix contains',
            },
            include_revoked: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/merchant/charges': {
        path: '/merchant/charges',
        sorts: [
            'created_at',
            'captured_at',
            'settled_at',
            'amount_cents',
            'refunded_cents',
            'state',
            'cof_intent',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'pending',
                    'authorized',
                    'in_review',
                    'approved',
                    'declined',
                    'unknown',
                    'voided',
                    'refunded',
                    'partially_refunded',
                    'duplicate',
                    'invalid',
                    'error',
                ],
            },
            cof_intent: {
                array: true,
                values: [
                    'one_off',
                    'one_off_store',
                    'sub_initial',
                    'trial_initial',
                    'card_update_cit',
                    'renewal_mit',
                    'buyer_cit_on_file',
                    'unscheduled_mit',
                ],
            },
            order_public_id: {
                array: true,
                values: null,
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            subscription_public_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'id, order id, buyer email or card last 4 contains',
            },
            customer_ref: {
                array: false,
                values: null,
                description:
                    "exact match on the merchant's customer reference; charges made before BM-35 rev 5 hold none (BM-35 § 60)",
            },
            customer_id: {
                array: false,
                values: null,
                description:
                    "exact match on the customer's cus_ id; charges of a session without a customer hold none (BM-112 § 3)",
            },
        },
        export: null,
    },
    '/merchant/checkout-sessions': {
        path: '/merchant/checkout-sessions',
        sorts: [
            'created_at',
            'expires_at',
            'completed_at',
            'state',
            'mode',
            'buyer_email',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'open',
                    'quoted',
                    'paying',
                    'pending',
                    'in_review',
                    'paid',
                    'declined',
                    'expired',
                    'cancelled',
                    'refused',
                    'saved',
                ],
            },
            mode: {
                array: true,
                values: ['one_off', 'plan', 'plan_change', 'setup'],
            },
            source: {
                array: true,
                values: [
                    'api',
                    'dashboard',
                    'billing',
                    'system',
                    'portal',
                    'console',
                    'renewal_auth',
                ],
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, buyer email or buyer name contains',
            },
        },
        export: null,
    },
    '/merchant/customers': {
        path: '/merchant/customers',
        sorts: [
            'last_order_at',
            'created_at',
            'first_order_at',
            'orders_count',
            'refunded_cents',
            'customer_ref',
        ],
        defaultSort: '-last_order_at,-created_at',
        date: null,
        cursor: false,
        filters: {
            customer_ref: {
                array: false,
                values: null,
                description: "exact match on the merchant's customer reference",
            },
            customer_id: {
                array: false,
                values: null,
                description:
                    "exact match on the customer's cus_ id (BM-112 § 3)",
            },
            buyer_email: {
                array: false,
                values: null,
                description:
                    'a customer any of whose orders has this email, or a customer with no order whose own email it is; exact match on the lowercased input',
            },
        },
        export: null,
    },
    '/merchant/disputes': {
        path: '/merchant/disputes',
        sorts: [
            'opened_at',
            'evidence_due_at',
            'closed_at',
            'amount_cents',
            'fee_cents',
            'status',
            'source',
            'reason_code',
            'merchant_id',
        ],
        defaultSort: '-opened_at',
        date: 'opened_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'open',
                    'evidence_submitted',
                    'won',
                    'lost',
                    'accepted',
                    'expired',
                ],
            },
            source: {
                array: true,
                values: ['chargeback'],
            },
            q: {
                array: false,
                values: null,
                description:
                    'dispute, charge or order id, or reason code contains',
            },
        },
        export: {
            path: '/merchant/disputes/export',
            columns: [
                'id',
                'merchant_id',
                'charge_id',
                'order_id',
                'source',
                'reason_code',
                'amount_cents',
                'fee_cents',
                'status',
                'outcome',
                'evidence_due_at',
                'evidence_count',
                'opened_at',
                'closed_at',
            ],
        },
    },
    '/merchant/holds': {
        path: '/merchant/holds',
        sorts: ['placed_at', 'released_at', 'amount_cents', 'source'],
        defaultSort: '-placed_at',
        date: 'placed_at',
        cursor: false,
        filters: {
            source: {
                array: true,
                values: ['staff', 'risk', 'api'],
            },
            include_released: {
                array: false,
                values: null,
                description:
                    'true to list released holds too (default: open holds only)',
            },
        },
        export: null,
    },
    '/merchant/invitations': {
        path: '/merchant/invitations',
        sorts: ['created_at', 'expires_at', 'email', 'name'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            role: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'email or name contains',
            },
        },
        export: null,
    },
    '/merchant/notifications': {
        path: '/merchant/notifications',
        sorts: ['created_at', 'read_at', 'template_key'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            read: {
                array: false,
                values: null,
            },
            template_key: {
                array: true,
                values: null,
            },
            category: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/merchant/orders': {
        path: '/merchant/orders',
        sorts: [
            'created_at',
            'captured_at',
            'total_cents',
            'subtotal_cents',
            'refunded_cents',
            'status',
            'buyer_email',
            'buyer_name',
            'source',
            'fulfilled_at',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'paid',
                    'fulfilled',
                    'refunded',
                    'partially_refunded',
                    'access_revoked',
                ],
            },
            store_id: {
                array: true,
                values: null,
                description:
                    'BM-86 decision 7: the store(s) the orders belong to',
            },
            source: {
                array: true,
                values: ['hosted', 'server', 'renewal', 'console'],
            },
            subscription_public_id: {
                array: true,
                values: null,
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            buyer_email: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'id, buyer email, buyer name or charge id contains',
            },
            customer_ref: {
                array: false,
                values: null,
                description:
                    "exact match on the merchant's customer reference; orders of sessions without one hold none (BM-35 § 59)",
            },
            customer_id: {
                array: false,
                values: null,
                description:
                    "exact match on the customer's cus_ id; orders of sessions without a customer hold none (BM-112 § 3)",
            },
            reference: {
                array: false,
                values: null,
                description:
                    "exact match on the merchant's own order reference; not unique, so several orders may match (BM-35 § 64)",
            },
        },
        export: {
            path: '/merchant/orders/export',
            columns: [
                'id',
                'session_id',
                'subscription_id',
                'buyer_id',
                'buyer_email',
                'buyer_name',
                'status',
                'subtotal_cents',
                'tax_cents',
                'total_cents',
                'refunded_cents',
                'currency',
                'tax_fallback',
                'charge_id',
                'card',
                'source',
                'captured_at',
                'fulfilment_due_at',
                'fulfilled_at',
                'access_revoked_at',
                'created_at',
            ],
        },
    },
    '/merchant/payment-methods': {
        path: '/merchant/payment-methods',
        sorts: ['created_at', 'brand', 'last4', 'exp_year', 'buyer_id'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            buyer_id: {
                array: true,
                values: null,
            },
            customer_id: {
                array: true,
                values: null,
                description: "the customer's cards by customer id",
            },
            brand: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, last 4 or buyer email contains',
            },
        },
        export: null,
    },
    '/merchant/payouts': {
        path: '/merchant/payouts',
        sorts: ['created_at', 'sent_at', 'amount_cents', 'state'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'pending',
                    'rejected_by_staff',
                    'approved',
                    'submitted',
                    'submission_failed',
                    'rejected_by_bank',
                    'sent',
                    'returned',
                    'settled',
                    'failed',
                    'unclaimed',
                ],
            },
        },
        export: null,
    },
    '/merchant/prices': {
        path: '/merchant/prices',
        sorts: [
            'created_at',
            'price_version',
            'amount_cents',
            'active_from',
            'active_to',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            product_id: {
                array: true,
                values: null,
            },
            active: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/merchant/products': {
        path: '/merchant/products',
        sorts: ['created_at', 'updated_at', 'name', 'status', 'tax_code'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['active', 'archived'],
            },
            store_id: {
                array: true,
                values: null,
                description:
                    'BM-86 decision 7: the store(s) the products belong to',
            },
            id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'name, description or id contains',
            },
        },
        export: null,
    },
    '/merchant/refunds': {
        path: '/merchant/refunds',
        sorts: ['created_at', 'issued_at', 'amount_cents', 'state', 'source'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'pending_approval',
                    'rejected',
                    'sending',
                    'issued',
                    'failed',
                    'unknown',
                ],
            },
            source: {
                array: true,
                values: ['api', 'dashboard', 'staff', 'system'],
            },
            charge_id: {
                array: true,
                values: null,
                description:
                    'refunds of these charges (chg_ ids), the name webhooks deliver (BM-112 D-36)',
            },
            charge_public_id: {
                array: true,
                values: null,
                description:
                    'Older name of charge_id[]. Still read; a request that sends it still succeeds (BM-112 D-36).',
            },
            q: {
                array: false,
                values: null,
                description: 'id or reason contains',
            },
        },
        export: {
            path: '/merchant/refunds/export',
            columns: [
                'id',
                'charge_id',
                'amount_cents',
                'currency',
                'reason',
                'state',
                'source',
                'initiated_by',
                'approval_id',
                'failure_reason',
                'issued_at',
                'created_at',
            ],
        },
    },
    '/merchant/reports/alerts': {
        path: '/merchant/reports/alerts',
        sorts: [
            'state',
            'raised_at',
            'resolved_at',
            'last_seen_at',
            'severity',
            'rule_key',
        ],
        defaultSort: 'state,-raised_at',
        date: 'raised_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['open', 'resolved'],
            },
            severity: {
                array: true,
                values: ['urgent', 'warning'],
            },
            rule_key: {
                array: true,
                values: [
                    'approval_rate_drop',
                    'decline_spike',
                    'volume_spike',
                    'volume_drop',
                    'conversion_drop',
                    'nmi_error_budget',
                    'tax_fallback',
                    'refund_spike',
                    'chargeback_rate',
                    'webhook_failures',
                    'payout_failed',
                    'freshness',
                    'reconciliation_gap',
                    'charge_unrecorded',
                    'charge_void_failed',
                    'charge_late_sale_voided',
                    'renewal_tax_unavailable',
                    'settlement_difference',
                    'ai_budget_80',
                    'ledger_integrity',
                    'payout_negative_carry',
                    'tax_remittance_difference',
                ],
            },
        },
        export: null,
    },
    '/merchant/reports/balance-transactions': {
        path: '/merchant/reports/balance-transactions',
        sorts: [
            'occurred_at',
            'available_on',
            'available_at',
            'gross_cents',
            'net_cents',
            'category',
            'merchant_id',
        ],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: false,
        filters: {
            category: {
                array: true,
                values: [
                    'sale',
                    'refund',
                    'chargeback',
                    'chargeback_reversal',
                    'chargeback_fee',
                    'reserve_hold',
                    'reserve_release',
                    'hold',
                    'hold_release',
                    'adjustment',
                    'payout',
                    'payout_reversal',
                    'payout_fee',
                    'payout_return_fee',
                ],
            },
            source_id: {
                array: true,
                values: null,
                description:
                    'an order, charge, refund, dispute, hold, adjustment or payout public id the row belongs to',
            },
            payout_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'an id contains',
            },
        },
        export: {
            path: '/merchant/reports/balance-transactions/export',
            columns: [
                'id',
                'occurred_at',
                'available_on',
                'available_at',
                'category',
                'gross_cents',
                'tax_cents',
                'fee_cents',
                'reserve_cents',
                'net_cents',
                'currency',
                'source_type',
                'source_id',
                'order_id',
                'charge_id',
                'entry_id',
                'payout_id',
                'statement_id',
                'memo',
                'merchant_id',
            ],
        },
    },
    '/merchant/reports/charges': {
        path: '/merchant/reports/charges',
        sorts: [
            'occurred_at',
            'amount_cents',
            'state',
            'captured_at',
            'settled_at',
            'merchant_id',
            'decline_code',
            'decline_category',
        ],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['approved', 'declined', 'settled'],
            },
            order_id: {
                array: true,
                values: null,
            },
            subscription_id: {
                array: true,
                values: null,
            },
            decline_category: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, order id or card last 4 contains',
            },
        },
        export: null,
    },
    '/merchant/reports/disputes': {
        path: '/merchant/reports/disputes',
        sorts: [
            'opened_at',
            'amount_cents',
            'fee_cents',
            'status',
            'evidence_due_at',
            'closed_at',
            'merchant_id',
            'source',
            'reason_code',
        ],
        defaultSort: '-opened_at',
        date: 'opened_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'open',
                    'evidence_submitted',
                    'won',
                    'lost',
                    'accepted',
                    'expired',
                ],
            },
            source: {
                array: true,
                values: null,
            },
            charge_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, charge id, order id or reason code contains',
            },
        },
        export: null,
    },
    '/merchant/reports/orders': {
        path: '/merchant/reports/orders',
        sorts: [
            'captured_at',
            'total_cents',
            'subtotal_cents',
            'tax_cents',
            'refunded_cents',
            'fee_cents',
            'status',
            'buyer_email',
            'merchant_id',
            'fulfilled_at',
            'line_count',
            'source',
        ],
        defaultSort: '-captured_at',
        date: 'captured_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'paid',
                    'fulfilled',
                    'refunded',
                    'partially_refunded',
                    'access_revoked',
                ],
            },
            buyer_email: {
                array: true,
                values: null,
            },
            subscription_id: {
                array: true,
                values: null,
            },
            source: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, buyer email or first line name contains',
            },
        },
        export: null,
    },
    '/merchant/reports/payouts': {
        path: '/merchant/reports/payouts',
        sorts: ['occurred_at', 'amount_cents', 'state', 'merchant_id'],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['pending', 'sent', 'settled', 'failed', 'unclaimed'],
            },
            statement_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/merchant/reports/refunds': {
        path: '/merchant/reports/refunds',
        sorts: ['occurred_at', 'amount_cents', 'merchant_id', 'initiated_by'],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: false,
        filters: {
            charge_id: {
                array: true,
                values: null,
            },
            order_id: {
                array: true,
                values: null,
            },
            initiated_by: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, charge id or order id contains',
            },
        },
        export: null,
    },
    '/merchant/reports/statements': {
        path: '/merchant/reports/statements',
        sorts: [
            'period_end',
            'period_start',
            'sales_cents',
            'refunds_cents',
            'fees_cents',
            'chargebacks_cents',
            'net_cents',
            'payout_cents',
            'merchant_id',
            'occurred_at',
        ],
        defaultSort: '-period_end',
        date: 'period_end',
        cursor: false,
        filters: {},
        export: null,
    },
    '/merchant/reports/subscriptions': {
        path: '/merchant/reports/subscriptions',
        sorts: [
            'started_at',
            'current_period_end',
            'next_charge_at',
            'trial_end',
            'amount_cents',
            'status',
            'buyer_email',
            'price_id',
            'merchant_id',
        ],
        defaultSort: '-started_at',
        date: 'started_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'trialing',
                    'active',
                    'past_due',
                    'paused',
                    'cancelled',
                    'ended',
                ],
            },
            price_id: {
                array: true,
                values: null,
            },
            buyer_email: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id or buyer email contains',
            },
        },
        export: null,
    },
    '/merchant/risk/reviews': {
        path: '/merchant/risk/reviews',
        sorts: ['opened_at', 'amount_cents'],
        defaultSort: '-opened_at',
        date: 'opened_at',
        cursor: false,
        filters: {},
        export: null,
    },
    '/merchant/statements': {
        path: '/merchant/statements',
        sorts: [
            'period_start',
            'period_end',
            'issued_at',
            'merchant_id',
            'net_cents',
            'payout_cents',
            'sales_cents',
            'closing_cents',
            'state',
        ],
        defaultSort: '-period_start',
        date: 'period_start',
        cursor: false,
        filters: {
            period: {
                array: true,
                values: null,
            },
            state: {
                array: true,
                values: [
                    'issued',
                    'carried_forward',
                    'paid',
                    'not_paid',
                    'offset',
                ],
            },
        },
        export: null,
    },
    '/merchant/statements/{statement}/lines': {
        path: '/merchant/statements/{statement}/lines',
        sorts: ['posted_at', 'amount_cents', 'line_type', 'occurred_at'],
        defaultSort: 'posted_at',
        date: null,
        cursor: false,
        filters: {
            line_type: {
                array: true,
                values: null,
            },
            direction: {
                array: true,
                values: ['credit', 'debit'],
            },
            record_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'entry key, record, order or charge id contains',
            },
        },
        export: null,
    },
    '/merchant/subscriptions': {
        path: '/merchant/subscriptions',
        sorts: [
            'created_at',
            'status',
            'amount_cents',
            'current_period_end',
            'next_charge_at',
            'trial_end',
            'cancelled_at',
            'buyer_email',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'trialing',
                    'active',
                    'past_due',
                    'paused',
                    'cancelled',
                ],
            },
            store_id: {
                array: true,
                values: null,
                description:
                    'BM-86 decision 7: the store(s) the subscriptions belong to',
            },
            cancel_source: {
                array: true,
                values: [
                    'buyer',
                    'merchant_api',
                    'merchant',
                    'staff',
                    'dunning',
                    'dispute',
                    'system',
                ],
            },
            cancel_at_period_end: {
                array: false,
                values: null,
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            price_public_id: {
                array: true,
                values: null,
            },
            buyer_email: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, buyer email or origin order id contains',
            },
            customer_ref: {
                array: false,
                values: null,
                description:
                    "exact match on the merchant's customer reference; subscriptions started before it was carried hold none (BM-35 § 61)",
            },
            customer_id: {
                array: false,
                values: null,
                description:
                    "exact match on the customer's cus_ id; subscriptions of an order without a customer hold none (BM-112 § 3)",
            },
        },
        export: null,
    },
    '/merchant/subscriptions/{subscription}/periods': {
        path: '/merchant/subscriptions/{subscription}/periods',
        sorts: [
            'number',
            'period_start',
            'due_at',
            'state',
            'total_cents',
            'paid_at',
        ],
        defaultSort: 'number',
        date: 'due_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'scheduled',
                    'charging',
                    'pending',
                    'paid',
                    'declined',
                    'cancelled',
                    'skipped',
                ],
            },
        },
        export: null,
    },
    '/merchant/tax-codes': {
        path: '/merchant/tax-codes',
        sorts: ['code', 'label'],
        defaultSort: 'code',
        date: null,
        cursor: false,
        filters: {
            q: {
                array: false,
                values: null,
                description: 'code or label contains',
            },
        },
        export: null,
    },
    '/merchant/users': {
        path: '/merchant/users',
        sorts: [
            'created_at',
            'name',
            'email',
            'status',
            'role',
            'last_login_at',
        ],
        defaultSort: 'created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['invited', 'active', 'suspended', 'deactivated'],
            },
            role: {
                array: true,
                values: [
                    'owner',
                    'admin',
                    'finance',
                    'developer',
                    'support',
                    'viewer',
                ],
            },
            q: {
                array: false,
                values: null,
                description: 'name or email contains',
            },
        },
        export: null,
    },
    '/merchant/webhook-endpoints': {
        path: '/merchant/webhook-endpoints',
        sorts: [
            'created_at',
            'url',
            'description',
            'consecutive_failures',
            'disabled_at',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            disabled: {
                array: false,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'url, description or id contains',
            },
        },
        export: null,
    },
    '/merchant/webhook-endpoints/{endpoint}/deliveries': {
        path: '/merchant/webhook-endpoints/{endpoint}/deliveries',
        sorts: [
            'created_at',
            'event_type',
            'status',
            'attempts',
            'http_status',
            'last_attempted_at',
            'next_attempt_at',
            'delivered_at',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['pending', 'sending', 'succeeded', 'failed', 'dead'],
            },
            event_type: {
                array: true,
                values: null,
            },
            http_status: {
                array: true,
                values: null,
            },
            replay: {
                array: false,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'event id or delivery id contains',
            },
        },
        export: null,
    },
    '/platform/tenants': {
        path: '/platform/tenants',
        sorts: ['slug', 'display_name', 'status', 'environment', 'created_at'],
        defaultSort: 'slug',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/adjustments': {
        path: '/staff/adjustments',
        sorts: [
            'created_at',
            'decided_at',
            'amount_cents',
            'state',
            'direction',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            state: {
                array: true,
                values: [
                    'pending_approval',
                    'posted',
                    'rejected',
                    'expired',
                    'withdrawn',
                ],
            },
            direction: {
                array: true,
                values: ['credit_merchant', 'debit_merchant'],
            },
        },
        export: {
            path: '/staff/adjustments/export',
            columns: [
                'id',
                'merchant_id',
                'amount_cents',
                'direction',
                'reason',
                'state',
                'requested_by',
                'approval_id',
                'decided_by',
                'decided_at',
                'created_at',
            ],
        },
    },
    '/staff/ai/audit': {
        path: '/staff/ai/audit',
        sorts: [
            'created_at',
            'board',
            'surface',
            'actor_id',
            'input_tokens',
            'output_tokens',
            'cost_micros',
            'duration_ms',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            board: {
                array: true,
                values: ['admin', 'merchant', 'v1', 'buyer'],
            },
            surface: {
                array: true,
                values: null,
            },
            actor_id: {
                array: true,
                values: null,
            },
            merchant_id: {
                array: true,
                values: null,
            },
            subject_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, surface, subject or actor contains',
            },
        },
        export: null,
    },
    '/staff/ai/calls': {
        path: '/staff/ai/calls',
        sorts: [
            'created_at',
            'board',
            'surface',
            'actor_id',
            'input_tokens',
            'output_tokens',
            'cost_micros',
            'duration_ms',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            board: {
                array: true,
                values: ['admin', 'merchant', 'v1', 'buyer'],
            },
            surface: {
                array: true,
                values: null,
            },
            actor_id: {
                array: true,
                values: null,
            },
            merchant_id: {
                array: true,
                values: null,
            },
            subject_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, surface, subject or actor contains',
            },
        },
        export: null,
    },
    '/staff/alerts': {
        path: '/staff/alerts',
        sorts: [
            'raised_at',
            'resolved_at',
            'severity',
            'state',
            'rule_key',
            'scope',
            'merchant_id',
            'acknowledged_at',
            'silenced_until',
        ],
        defaultSort: '-raised_at',
        date: 'raised_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['open', 'acknowledged', 'silenced', 'resolved'],
            },
            severity: {
                array: true,
                values: ['urgent', 'warning'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            rule_key: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, rule key or scope contains',
            },
        },
        export: null,
    },
    '/staff/approvals': {
        path: '/staff/approvals',
        sorts: [
            'created_at',
            'expires_at',
            'decided_at',
            'state',
            'action',
            'merchant_id',
            'requested_by',
            'decided_by',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['pending', 'granted', 'rejected', 'expired'],
            },
            action: {
                array: true,
                values: null,
            },
            merchant_id: {
                array: true,
                values: null,
            },
            requested_by: {
                array: true,
                values: null,
            },
            decided_by: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'summary, id or subject id contains',
            },
        },
        export: null,
    },
    '/staff/audit': {
        path: '/staff/audit',
        sorts: ['occurred_at', 'action', 'service', 'actor_id'],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: true,
        filters: {
            actor_id: {
                array: true,
                values: null,
            },
            merchant_id: {
                array: true,
                values: null,
            },
            entity_id: {
                array: true,
                values: null,
            },
            entity_type: {
                array: true,
                values: null,
            },
            service: {
                array: true,
                values: null,
            },
            action: {
                array: true,
                values: null,
            },
            audience: {
                array: true,
                values: null,
            },
            correlation_id: {
                array: true,
                values: null,
            },
            actor_type: {
                array: true,
                values: ['staff', 'user', 'api_key', 'buyer', 'system'],
                description: 'BM-93',
            },
            organization_id: {
                array: true,
                values: null,
                description: 'BM-93',
            },
            store_id: {
                array: true,
                values: null,
                description: 'BM-93',
            },
            on_behalf_of: {
                array: true,
                values: null,
                description:
                    'BM-93: the staff member behind an impersonated session',
            },
        },
        export: {
            path: '/staff/audit/export',
            columns: [
                'occurred_at',
                'actor_id',
                'audience',
                'service',
                'action',
                'entity_type',
                'entity_id',
                'merchant_id',
                'before',
                'after',
                'correlation_id',
                'event_id',
            ],
        },
    },
    '/staff/bank-accounts': {
        path: '/staff/bank-accounts',
        sorts: ['created_at', 'name', 'type', 'status', 'bank_name'],
        defaultSort: 'name',
        date: 'created_at',
        cursor: false,
        filters: {
            type: {
                array: true,
                values: ['trust', 'operating'],
            },
            status: {
                array: true,
                values: ['active', 'closed'],
            },
            q: {
                array: false,
                values: null,
                description: 'name or bank contains',
            },
        },
        export: null,
    },
    '/staff/cards': {
        path: '/staff/cards',
        sorts: ['tenant_default', 'name', 'side', 'active_from', 'version'],
        defaultSort: '-tenant_default,name',
        date: 'active_from',
        cursor: false,
        filters: {
            side: {
                array: true,
                values: ['cost', 'fee'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'name, id or merchant id contains',
            },
            include_closed: {
                array: false,
                values: null,
                description: 'every version, not only the open one',
            },
        },
        export: null,
    },
    '/staff/cases': {
        path: '/staff/cases',
        sorts: [
            'created_at',
            'updated_at',
            'closed_at',
            'due_at',
            'priority',
            'state',
            'kind',
            'title',
            'merchant_id',
            'assigned_to',
            'notes_count',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['open', 'waiting', 'closed'],
            },
            kind: {
                array: true,
                values: [
                    'dispute',
                    'reconciliation',
                    'kill_switch',
                    'offboarding',
                    'onboarding',
                    'manual',
                ],
            },
            priority: {
                array: true,
                values: ['low', 'normal', 'high', 'urgent'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            assigned_to: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'title or id contains',
            },
            tag: {
                array: true,
                values: null,
            },
            overdue: {
                array: false,
                values: null,
                description:
                    'BM-136: true = open or waiting cases whose due_at has passed',
            },
        },
        export: {
            path: '/staff/cases/export',
            columns: [
                'id',
                'title',
                'kind',
                'state',
                'priority',
                'merchant_id',
                'assigned_to',
                'opened_by',
                'notes_count',
                'tags',
                'created_at',
                'updated_at',
                'closed_at',
                'closed_reason',
                'due_at',
            ],
        },
    },
    '/staff/cases/{case}/notes': {
        path: '/staff/cases/{case}/notes',
        sorts: ['created_at'],
        defaultSort: 'created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            author_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/charge-reviews': {
        path: '/staff/charge-reviews',
        sorts: ['opened_at'],
        defaultSort: 'opened_at',
        date: 'opened_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['open', 'approved', 'rejected', 'expired'],
                description:
                    'open (no decision yet) or a decided value; with no state filter the list holds open items only',
            },
        },
        export: null,
    },
    '/staff/charges': {
        path: '/staff/charges',
        sorts: [
            'created_at',
            'captured_at',
            'settled_at',
            'amount_cents',
            'refunded_cents',
            'state',
            'cof_intent',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'pending',
                    'authorized',
                    'in_review',
                    'approved',
                    'declined',
                    'unknown',
                    'voided',
                    'refunded',
                    'partially_refunded',
                    'duplicate',
                    'invalid',
                    'error',
                ],
            },
            cof_intent: {
                array: true,
                values: [
                    'one_off',
                    'one_off_store',
                    'sub_initial',
                    'trial_initial',
                    'card_update_cit',
                    'renewal_mit',
                    'buyer_cit_on_file',
                    'unscheduled_mit',
                ],
            },
            order_public_id: {
                array: true,
                values: null,
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            subscription_public_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'id, order id, buyer email or card last 4 contains',
            },
            merchant_id: {
                array: true,
                values: null,
            },
            customer_ref: {
                array: false,
                values: null,
                description:
                    "exact match on the merchant's customer reference; charges made before BM-35 rev 5 hold none (BM-35 § 60)",
            },
            customer_id: {
                array: false,
                values: null,
                description:
                    "exact match on the customer's cus_ id; charges of a session without a customer hold none (BM-112 § 3)",
            },
            three_ds: {
                array: false,
                values: ['yes', 'no'],
                description:
                    'yes: the charges whose flow triggered 3-D Secure (a recorded check, or a posted cardholder_auth, eci or three_ds_version; bm-161 QA); no: every other charge. Any other value is a 422 naming three_ds',
            },
        },
        export: null,
    },
    '/staff/comments': {
        path: '/staff/comments',
        sorts: ['created_at', 'author_id'],
        defaultSort: 'created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            author_id: {
                array: true,
                values: null,
            },
            subject_type: {
                array: false,
                values: [
                    'merchant',
                    'charge',
                    'refund',
                    'dispute',
                    'subscription',
                    'order',
                    'case',
                    'organization',
                    'store',
                    'user',
                ],
            },
            subject_id: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/disputes': {
        path: '/staff/disputes',
        sorts: [
            'opened_at',
            'evidence_due_at',
            'closed_at',
            'amount_cents',
            'fee_cents',
            'status',
            'source',
            'reason_code',
            'merchant_id',
        ],
        defaultSort: '-opened_at',
        date: 'opened_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'open',
                    'evidence_submitted',
                    'won',
                    'lost',
                    'accepted',
                    'expired',
                ],
            },
            source: {
                array: true,
                values: ['chargeback'],
            },
            q: {
                array: false,
                values: null,
                description:
                    'dispute, charge or order id, or reason code contains',
            },
            merchant_id: {
                array: true,
                values: null,
            },
        },
        export: {
            path: '/staff/disputes/export',
            columns: [
                'id',
                'merchant_id',
                'charge_id',
                'order_id',
                'source',
                'reason_code',
                'amount_cents',
                'fee_cents',
                'status',
                'outcome',
                'evidence_due_at',
                'evidence_count',
                'opened_at',
                'closed_at',
            ],
        },
    },
    '/staff/disputes/rows': {
        path: '/staff/disputes/rows',
        sorts: ['received_at', 'occurred_on', 'amount_cents', 'state'],
        defaultSort: '-received_at',
        date: 'received_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['matched', 'unmatched', 'skipped'],
            },
            q: {
                array: false,
                values: null,
                description: 'chargeback id, card last four or reason contains',
            },
        },
        export: null,
    },
    '/staff/flags': {
        path: '/staff/flags',
        sorts: [
            'key',
            'kind',
            'default_on',
            'owner',
            'ticket',
            'expires_at',
            'archived_at',
            'updated_at',
        ],
        defaultSort: 'key',
        date: 'expires_at',
        cursor: false,
        filters: {
            kind: {
                array: true,
                values: ['release', 'kill_switch'],
            },
            archived: {
                array: false,
                values: null,
            },
            expiring: {
                array: false,
                values: null,
            },
            owner: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'key, description or ticket contains',
            },
        },
        export: null,
    },
    '/staff/flags/{key}/changes': {
        path: '/staff/flags/{key}/changes',
        sorts: ['created_at', 'version', 'changed_by'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            changed_by: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/holds': {
        path: '/staff/holds',
        sorts: [
            'placed_at',
            'released_at',
            'amount_cents',
            'merchant_id',
            'source',
        ],
        defaultSort: '-placed_at',
        date: 'placed_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            source: {
                array: true,
                values: ['staff', 'risk', 'api'],
            },
            include_released: {
                array: false,
                values: null,
                description:
                    'true to list released holds too (default: open holds only)',
            },
        },
        export: {
            path: '/staff/holds/export',
            columns: [
                'id',
                'merchant_id',
                'amount_cents',
                'source',
                'reason',
                'placed_by',
                'placed_at',
                'released_at',
                'release_requested_by',
                'release_reason',
                'approval_id',
            ],
        },
    },
    '/staff/http-logs': {
        path: '/staff/http-logs',
        sorts: [
            'created_at',
            'status',
            'duration_ms',
            'client',
            'host',
            'level',
            'method',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: true,
        filters: {
            client: {
                array: true,
                values: null,
            },
            level: {
                array: true,
                values: [
                    'debug',
                    'info',
                    'notice',
                    'warning',
                    'error',
                    'critical',
                    'alert',
                    'emergency',
                ],
            },
            host: {
                array: true,
                values: null,
            },
            merchant_id: {
                array: true,
                values: null,
            },
            correlation_id: {
                array: true,
                values: null,
            },
            charge_id: {
                array: true,
                values: null,
                description:
                    'the calls made while that charge was handled (BM-111)',
            },
            direction: {
                array: true,
                values: ['in', 'out'],
            },
            status: {
                array: true,
                values: null,
                description:
                    'exact HTTP status codes (404) or classes (2xx, 3xx, 4xx, 5xx)',
            },
        },
        export: null,
    },
    '/staff/invitations': {
        path: '/staff/invitations',
        sorts: ['created_at', 'expires_at', 'email', 'name'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            role: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'email or name contains',
            },
        },
        export: null,
    },
    '/staff/ledger/{merchant}': {
        path: '/staff/ledger/{merchant}',
        sorts: [
            'posted_at',
            'entry_type',
            'captured_at',
            'release_at',
            'order_id',
            'charge_id',
            'posted_by',
        ],
        defaultSort: '-posted_at',
        date: 'posted_at',
        cursor: true,
        filters: {
            entry_type: {
                array: true,
                values: [
                    'sale',
                    'sale_reserve',
                    'refund',
                    'refund_reserve',
                    'chargeback',
                    'chargeback_reversal',
                    'chargeback_fee',
                    'processing_cost',
                    'reserve_release',
                    'hold',
                    'hold_release',
                    'adjustment',
                    'payout',
                    'payout_reversal',
                    'statement_close',
                    'statement_close_reversal',
                    'payout_fee',
                    'payout_return_fee',
                    'payout_cost',
                    'tax_remittance',
                    'settlement_gross',
                    'settlement_fee',
                ],
            },
            order_id: {
                array: true,
                values: null,
            },
            charge_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'id, event reference, order, charge or memo contains',
            },
        },
        export: {
            path: '/staff/ledger/{merchant}/export',
            columns: [
                'id',
                'merchant_id',
                'posted_at',
                'entry_type',
                'amount_cents',
                'event_ref',
                'order_id',
                'charge_id',
                'captured_at',
                'release_at',
                'released',
                'memo',
                'approval_id',
                'posted_by',
            ],
        },
    },
    '/staff/ledger/ai/calls': {
        path: '/staff/ledger/ai/calls',
        sorts: [
            'created_at',
            'board',
            'surface',
            'actor_id',
            'input_tokens',
            'output_tokens',
            'cost_micros',
            'duration_ms',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            board: {
                array: true,
                values: ['tenant', 'platform', 'vendor'],
            },
            surface: {
                array: true,
                values: null,
            },
            actor_id: {
                array: true,
                values: null,
            },
            subject_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, surface, subject or actor contains',
            },
        },
        export: null,
    },
    '/staff/ledger/ap': {
        path: '/staff/ledger/ap',
        sorts: ['display_name', 'id', 'status', 'timezone'],
        defaultSort: 'display_name',
        date: null,
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            status: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/ledger/api-keys': {
        path: '/staff/ledger/api-keys',
        sorts: ['created_at', 'name', 'last_used_at'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            revoked: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/ledger/approvals': {
        path: '/staff/ledger/approvals',
        sorts: [
            'created_at',
            'expires_at',
            'decided_at',
            'state',
            'action',
            'merchant_id',
            'requested_by',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'pending',
                    'granted',
                    'rejected',
                    'expired',
                    'withdrawn',
                    'decided',
                ],
            },
            action: {
                array: true,
                values: [
                    'hold.release',
                    'adjustment',
                    'payout',
                    'approval_policy',
                    'tax_remittance',
                    'payout_mode',
                    'tenant_close',
                ],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            requested_by: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/ledger/dead-letters': {
        path: '/staff/ledger/dead-letters',
        sorts: [
            'received_at',
            'last_attempt_at',
            'resolved_at',
            'attempts',
            'error_key',
            'merchant_id',
            'type',
        ],
        defaultSort: '-received_at',
        date: 'received_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['open', 'resubmitted', 'discarded'],
            },
            error_key: {
                array: true,
                values: [
                    'tenant_mismatch',
                    'invalid_entry',
                    'unknown_entry_type',
                    'unknown_account_kind',
                    'merchant_scope',
                    'invalid_line',
                    'unbalanced',
                    'unknown_account',
                    'unknown_reversed_entry',
                    'key_conflict',
                    'posting_failed',
                ],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, entry key, event id or merchant id contains',
            },
        },
        export: null,
    },
    '/staff/ledger/group-roles': {
        path: '/staff/ledger/group-roles',
        sorts: ['issuer', 'claim', 'value', 'role'],
        defaultSort: 'issuer',
        date: null,
        cursor: false,
        filters: {
            issuer: {
                array: true,
                values: null,
            },
            claim: {
                array: true,
                values: null,
            },
            role_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/ledger/http-logs': {
        path: '/staff/ledger/http-logs',
        sorts: [
            'created_at',
            'status',
            'duration_ms',
            'client',
            'host',
            'method',
            'level',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: true,
        filters: {
            client: {
                array: true,
                values: null,
            },
            level: {
                array: true,
                values: [
                    'debug',
                    'info',
                    'notice',
                    'warning',
                    'error',
                    'critical',
                    'alert',
                    'emergency',
                ],
            },
            status: {
                array: true,
                values: null,
            },
            host: {
                array: true,
                values: null,
            },
            merchant_id: {
                array: true,
                values: null,
            },
            correlation_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'URL or correlation id contains',
            },
        },
        export: null,
    },
    '/staff/ledger/invitations': {
        path: '/staff/ledger/invitations',
        sorts: ['created_at', 'expires_at', 'email'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            q: {
                array: false,
                values: null,
                description: 'email or name contains',
            },
        },
        export: null,
    },
    '/staff/ledger/members': {
        path: '/staff/ledger/members',
        sorts: [
            'created_at',
            'updated_at',
            'email',
            'name',
            'status',
            'last_seen_at',
        ],
        defaultSort: 'created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['active', 'deactivated'],
            },
            role_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'email or name contains',
            },
        },
        export: null,
    },
    '/staff/ledger/merchants': {
        path: '/staff/ledger/merchants',
        sorts: ['display_name', 'id', 'status', 'timezone'],
        defaultSort: 'display_name',
        date: null,
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['draft', 'pending', 'approved', 'suspended', 'closed'],
            },
            id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'display name or merchant id contains',
            },
        },
        export: null,
    },
    '/staff/ledger/payout-instructions': {
        path: '/staff/ledger/payout-instructions',
        sorts: [
            'updated_at',
            'merchant_id',
            'verified_at',
            'bank_name',
            'set_by',
            'status',
        ],
        defaultSort: '-updated_at',
        date: 'updated_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            verification: {
                array: true,
                values: ['verified', 'unverified', 'failed'],
            },
        },
        export: null,
    },
    '/staff/ledger/payout-runs': {
        path: '/staff/ledger/payout-runs',
        sorts: [
            'created_at',
            'period_start',
            'period_end',
            'state',
            'total_cents',
            'executed_at',
            'requested_by',
            'payout_count',
        ],
        defaultSort: '-created_at',
        date: 'period_start',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'building',
                    'pending_approval',
                    'closing',
                    'approved',
                    'executing',
                    'done',
                    'rejected',
                    'expired',
                    'withdrawn',
                    'cancelled',
                    'failed',
                ],
            },
            requested_by: {
                array: true,
                values: null,
            },
        },
        export: {
            path: '/staff/ledger/payout-runs/export',
            columns: [
                'id',
                'period_start',
                'period_end',
                'state',
                'total_cents',
                'payout_count',
                'requested_by',
                'approval_id',
                'created_at',
                'executed_at',
            ],
        },
    },
    '/staff/ledger/payout-schedule/merchants': {
        path: '/staff/ledger/payout-schedule/merchants',
        sorts: ['updated_at', 'merchant_id', 'minimum_cents'],
        defaultSort: '-updated_at',
        date: null,
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/ledger/payouts': {
        path: '/staff/ledger/payouts',
        sorts: [
            'created_at',
            'sent_at',
            'settled_at',
            'amount_cents',
            'state',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            state: {
                array: true,
                values: [
                    'pending',
                    'rejected_by_staff',
                    'approved',
                    'submitted',
                    'submission_failed',
                    'rejected_by_bank',
                    'sent',
                    'returned',
                    'settled',
                    'failed',
                    'unclaimed',
                ],
            },
            status: {
                array: true,
                values: [
                    'pending',
                    'rejected_by_staff',
                    'approved',
                    'submitted',
                    'submission_failed',
                    'rejected_by_bank',
                    'sent',
                    'returned',
                    'settled',
                    'failed',
                    'unclaimed',
                ],
            },
            run_id: {
                array: true,
                values: null,
            },
        },
        export: {
            path: '/staff/ledger/payouts/export',
            columns: [
                'id',
                'merchant_id',
                'run_id',
                'statement_id',
                'amount_cents',
                'state',
                'corpay_ref',
                'failure_reason',
                'entry_id',
                'sent_at',
                'settled_at',
                'created_at',
            ],
        },
    },
    '/staff/ledger/periods': {
        path: '/staff/ledger/periods',
        sorts: ['period_start', 'kind', 'status', 'entries_count', 'closed_at'],
        defaultSort: '-period_start',
        date: 'period_start',
        cursor: true,
        filters: {
            kind: {
                array: true,
                values: ['day', 'month'],
            },
            status: {
                array: true,
                values: ['closed', 'integrity_failed'],
            },
        },
        export: null,
    },
    '/staff/ledger/reconciliation-runs': {
        path: '/staff/ledger/reconciliation-runs',
        sorts: ['run_date', 'kind', 'checked', 'finished_at', 'gap_count'],
        defaultSort: '-run_date',
        date: 'run_date',
        cursor: false,
        filters: {
            kind: {
                array: true,
                values: [
                    'ledger_vs_payments',
                    'payments_vs_nmi',
                    'billing_vs_payments',
                ],
            },
        },
        export: null,
    },
    '/staff/ledger/roles': {
        path: '/staff/ledger/roles',
        sorts: [
            'system',
            'created_at',
            'updated_at',
            'name',
            'key',
            'member_count',
            'color',
        ],
        defaultSort: '-system,created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            system: {
                array: false,
                values: null,
            },
            color: {
                array: true,
                values: [
                    'slate',
                    'red',
                    'amber',
                    'green',
                    'teal',
                    'blue',
                    'violet',
                    'pink',
                ],
            },
            q: {
                array: false,
                values: null,
                description: 'name or key contains',
            },
        },
        export: null,
    },
    '/staff/ledger/statements': {
        path: '/staff/ledger/statements',
        sorts: [
            'period_start',
            'period_end',
            'issued_at',
            'merchant_id',
            'net_cents',
            'payout_cents',
            'sales_cents',
            'closing_cents',
            'state',
        ],
        defaultSort: '-period_start',
        date: 'period_start',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            period: {
                array: true,
                values: null,
            },
            state: {
                array: true,
                values: [
                    'issued',
                    'carried_forward',
                    'paid',
                    'not_paid',
                    'offset',
                ],
            },
        },
        export: null,
    },
    '/staff/ledger/statements/{statement}/lines': {
        path: '/staff/ledger/statements/{statement}/lines',
        sorts: ['posted_at', 'amount_cents', 'line_type', 'occurred_at'],
        defaultSort: 'posted_at',
        date: null,
        cursor: false,
        filters: {
            line_type: {
                array: true,
                values: null,
            },
            direction: {
                array: true,
                values: ['credit', 'debit'],
            },
            record_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'entry key, record, order or charge id contains',
            },
        },
        export: null,
    },
    '/staff/ledger/sub-accounts': {
        path: '/staff/ledger/sub-accounts',
        sorts: ['display_name', 'id', 'status', 'timezone'],
        defaultSort: 'display_name',
        date: null,
        cursor: false,
        filters: {
            status: {
                array: true,
                values: null,
            },
            external_ref: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/ledger/tax/periods': {
        path: '/staff/ledger/tax/periods',
        sorts: ['period', 'recorded_at', 'net_cents'],
        defaultSort: '-period',
        date: null,
        cursor: false,
        filters: {},
        export: null,
    },
    '/staff/ledger/tax/remittances': {
        path: '/staff/ledger/tax/remittances',
        sorts: ['created_at', 'period', 'filed_cents', 'state'],
        defaultSort: '-created_at',
        date: null,
        cursor: false,
        filters: {
            state: {
                array: true,
                values: null,
            },
            period: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/ledger/webhook-endpoints/{endpoint}/deliveries': {
        path: '/staff/ledger/webhook-endpoints/{endpoint}/deliveries',
        sorts: ['created_at', 'status', 'event_type', 'attempts'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['pending', 'succeeded', 'failed', 'dead'],
            },
            event_type: {
                array: true,
                values: null,
            },
            event_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/merchants': {
        path: '/staff/merchants',
        sorts: [
            'created_at',
            'updated_at',
            'display_name',
            'legal_name',
            'status',
            'kyc_status',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['draft', 'pending', 'approved', 'suspended', 'closed'],
            },
            kyc_status: {
                array: true,
                values: [
                    'not_started',
                    'in_progress',
                    'submitted',
                    'verified',
                    'rejected',
                ],
            },
            id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'display or legal name, id or support email contains',
            },
            tag: {
                array: true,
                values: null,
            },
            provider: {
                array: true,
                values: null,
                description:
                    "the provider code of the merchant's live provider link (bm-111 § 1)",
            },
            payment_system: {
                array: true,
                values: null,
                description:
                    'a payment system the merchant has a row for (bm-111 § 1)',
            },
            provider_account_id: {
                array: true,
                values: null,
                description:
                    "the provider account id of the merchant's live provider link; a value that is not an integer is 422 (bm-111 § 1)",
            },
        },
        export: {
            path: '/staff/merchants/export',
            columns: [
                'id',
                'legal_name',
                'display_name',
                'status',
                'kyc_status',
                'support_email',
                'timezone',
                'tags',
                'created_at',
                'updated_at',
            ],
        },
    },
    '/staff/notification-templates': {
        path: '/staff/notification-templates',
        sorts: ['key', 'name', 'category', 'active', 'updated_at'],
        defaultSort: 'key',
        date: null,
        cursor: false,
        filters: {
            category: {
                array: true,
                values: null,
            },
            active: {
                array: false,
                values: null,
            },
            tenant_override: {
                array: false,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'key or name contains',
            },
        },
        export: null,
    },
    '/staff/notifications': {
        path: '/staff/notifications',
        sorts: ['created_at', 'read_at', 'template_key'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            read: {
                array: false,
                values: null,
            },
            template_key: {
                array: true,
                values: null,
            },
            category: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/notifications/log': {
        path: '/staff/notifications/log',
        sorts: [
            'created_at',
            'template_key',
            'channel',
            'status',
            'notifiable_type',
            'notifiable_id',
            'merchant_id',
            'read_at',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            template_key: {
                array: true,
                values: null,
            },
            channel: {
                array: true,
                values: null,
            },
            status: {
                array: true,
                values: ['pending', 'sent', 'failed', 'digested'],
            },
            notifiable_type: {
                array: true,
                values: null,
            },
            notifiable_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'title, id or source event contains',
            },
        },
        export: null,
    },
    '/staff/onboarding/applications': {
        path: '/staff/onboarding/applications',
        sorts: [
            'submitted_at',
            'created_at',
            'updated_at',
            'state',
            'legal_name',
            'display_name',
            'merchant_status',
            'merchant_id',
        ],
        defaultSort: 'submitted_at',
        date: 'submitted_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'draft',
                    'submitted',
                    'in_review',
                    'approved',
                    'rejected',
                    'needs_info',
                ],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'merchant name or id, application id contains',
            },
        },
        export: null,
    },
    '/staff/orders': {
        path: '/staff/orders',
        sorts: [
            'created_at',
            'captured_at',
            'total_cents',
            'subtotal_cents',
            'refunded_cents',
            'status',
            'buyer_email',
            'buyer_name',
            'source',
            'fulfilled_at',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'paid',
                    'fulfilled',
                    'refunded',
                    'partially_refunded',
                    'access_revoked',
                ],
            },
            store_id: {
                array: true,
                values: null,
                description:
                    'BM-86 decision 7: the store(s) the orders belong to',
            },
            source: {
                array: true,
                values: ['hosted', 'server', 'renewal', 'console'],
            },
            subscription_public_id: {
                array: true,
                values: null,
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            buyer_email: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'id, buyer email, buyer name or charge id contains',
            },
            merchant_id: {
                array: true,
                values: null,
            },
        },
        export: {
            path: '/staff/orders/export',
            columns: [
                'id',
                'merchant_id',
                'session_id',
                'subscription_id',
                'buyer_id',
                'buyer_email',
                'buyer_name',
                'status',
                'subtotal_cents',
                'tax_cents',
                'total_cents',
                'refunded_cents',
                'currency',
                'tax_fallback',
                'charge_id',
                'card',
                'source',
                'captured_at',
                'fulfilment_due_at',
                'fulfilled_at',
                'access_revoked_at',
                'created_at',
            ],
        },
    },
    '/staff/organizations': {
        path: '/staff/organizations',
        sorts: ['created_at', 'name', 'status'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['active', 'suspended', 'closed'],
            },
            q: {
                array: false,
                values: null,
                description:
                    'organization name, owner email or a merchant display name contains',
            },
        },
        export: null,
    },
    '/staff/payment-methods': {
        path: '/staff/payment-methods',
        sorts: ['created_at'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            customer_ref: {
                array: true,
                values: null,
            },
            status: {
                array: true,
                values: ['active', 'inactive', 'replaced', 'deleted'],
            },
            type: {
                array: true,
                values: null,
                description: 'the payment system code',
            },
            provider: {
                array: true,
                values: null,
                description: 'the opaque provider code',
            },
            offered_to_buyer: {
                array: false,
                values: null,
                description:
                    "true: the methods the hosted page's saved-card picker lists",
            },
        },
        export: null,
    },
    '/staff/platform/ai/audit': {
        path: '/staff/platform/ai/audit',
        sorts: [
            'created_at',
            'board',
            'surface',
            'actor_id',
            'input_tokens',
            'output_tokens',
            'cost_micros',
            'duration_ms',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            board: {
                array: true,
                values: ['tenant', 'platform', 'vendor'],
            },
            surface: {
                array: true,
                values: null,
            },
            actor_id: {
                array: true,
                values: null,
            },
            subject_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, surface, subject or actor contains',
            },
        },
        export: null,
    },
    '/staff/platform/ai/calls': {
        path: '/staff/platform/ai/calls',
        sorts: [
            'created_at',
            'board',
            'surface',
            'actor_id',
            'input_tokens',
            'output_tokens',
            'cost_micros',
            'duration_ms',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            board: {
                array: true,
                values: ['tenant', 'platform', 'vendor'],
            },
            surface: {
                array: true,
                values: null,
            },
            actor_id: {
                array: true,
                values: null,
            },
            subject_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, surface, subject or actor contains',
            },
        },
        export: null,
    },
    '/staff/platform/audit': {
        path: '/staff/platform/audit',
        sorts: ['created_at', 'action', 'entity_type'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            action: {
                array: true,
                values: null,
            },
            entity_type: {
                array: true,
                values: null,
            },
            actor_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'action or entity id contains',
            },
        },
        export: null,
    },
    '/staff/platform/invitations': {
        path: '/staff/platform/invitations',
        sorts: ['created_at', 'expires_at', 'email'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            q: {
                array: false,
                values: null,
                description: 'email or name contains',
            },
        },
        export: null,
    },
    '/staff/platform/members': {
        path: '/staff/platform/members',
        sorts: [
            'created_at',
            'updated_at',
            'email',
            'name',
            'status',
            'last_seen_at',
        ],
        defaultSort: 'created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['active', 'deactivated'],
            },
            role_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'email or name contains',
            },
        },
        export: null,
    },
    '/staff/platform/roles': {
        path: '/staff/platform/roles',
        sorts: [
            'system',
            'created_at',
            'updated_at',
            'name',
            'key',
            'member_count',
            'color',
        ],
        defaultSort: '-system,created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            system: {
                array: false,
                values: null,
            },
            color: {
                array: true,
                values: [
                    'slate',
                    'red',
                    'amber',
                    'green',
                    'teal',
                    'blue',
                    'violet',
                    'pink',
                ],
            },
            q: {
                array: false,
                values: null,
                description: 'name or key contains',
            },
        },
        export: null,
    },
    '/staff/platform/tenants': {
        path: '/staff/platform/tenants',
        sorts: ['slug', 'display_name', 'status', 'environment', 'created_at'],
        defaultSort: 'slug',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/pricing/cards': {
        path: '/staff/pricing/cards',
        sorts: ['tenant_default', 'name', 'side', 'active_from', 'version'],
        defaultSort: '-tenant_default,name',
        date: 'active_from',
        cursor: false,
        filters: {
            side: {
                array: true,
                values: ['cost', 'fee'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
            include_closed: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/queues/{queue}': {
        path: '/staff/queues/{queue}',
        sorts: [
            'created_at',
            'done_at',
            'state',
            'status',
            'title',
            'merchant_id',
            'assigned_to',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['open', 'done'],
            },
            status: {
                array: true,
                values: ['new', 'under_review', 'needs_info', 'done'],
                description:
                    "BM-66: the item's own lifecycle (the board columns)",
            },
            merchant_id: {
                array: true,
                values: null,
            },
            assigned_to: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'title or subject id contains',
            },
        },
        export: null,
    },
    '/staff/receivables': {
        path: '/staff/receivables',
        sorts: [
            'merchant_id',
            'open_cents',
            'sale_count',
            'oldest_captured_at',
        ],
        defaultSort: '-open_cents',
        date: null,
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/refunds': {
        path: '/staff/refunds',
        sorts: [
            'created_at',
            'issued_at',
            'amount_cents',
            'state',
            'source',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'pending_approval',
                    'rejected',
                    'sending',
                    'issued',
                    'failed',
                    'unknown',
                ],
            },
            source: {
                array: true,
                values: ['api', 'dashboard', 'staff', 'system'],
            },
            charge_id: {
                array: true,
                values: null,
                description:
                    'refunds of these charges (chg_ ids), the name webhooks deliver (BM-112 D-36)',
            },
            charge_public_id: {
                array: true,
                values: null,
                description:
                    'Older name of charge_id[]. Still read; a request that sends it still succeeds (BM-112 D-36).',
            },
            q: {
                array: false,
                values: null,
                description: 'id or reason contains',
            },
            order_id: {
                array: true,
                values: null,
                description:
                    "refunds of these orders (ord_ ids): the refund's charge is the order's charge (bm-147 D-22)",
            },
            merchant_id: {
                array: true,
                values: null,
            },
        },
        export: {
            path: '/staff/refunds/export',
            columns: [
                'id',
                'charge_id',
                'merchant_id',
                'amount_cents',
                'currency',
                'reason',
                'state',
                'source',
                'initiated_by',
                'approval_id',
                'failure_reason',
                'issued_at',
                'created_at',
            ],
        },
    },
    '/staff/reports/alerts': {
        path: '/staff/reports/alerts',
        sorts: [
            'state',
            'raised_at',
            'resolved_at',
            'last_seen_at',
            'severity',
            'rule_key',
        ],
        defaultSort: 'state,-raised_at',
        date: 'raised_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['open', 'resolved'],
            },
            severity: {
                array: true,
                values: ['urgent', 'warning'],
            },
            rule_key: {
                array: true,
                values: [
                    'approval_rate_drop',
                    'decline_spike',
                    'volume_spike',
                    'volume_drop',
                    'conversion_drop',
                    'nmi_error_budget',
                    'tax_fallback',
                    'refund_spike',
                    'chargeback_rate',
                    'webhook_failures',
                    'payout_failed',
                    'freshness',
                    'reconciliation_gap',
                    'charge_unrecorded',
                    'charge_void_failed',
                    'charge_late_sale_voided',
                    'renewal_tax_unavailable',
                    'settlement_difference',
                    'ai_budget_80',
                    'ledger_integrity',
                    'payout_negative_carry',
                    'tax_remittance_difference',
                ],
            },
            merchant_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/reports/balance-transactions': {
        path: '/staff/reports/balance-transactions',
        sorts: [
            'occurred_at',
            'available_on',
            'available_at',
            'gross_cents',
            'net_cents',
            'category',
            'merchant_id',
        ],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            category: {
                array: true,
                values: [
                    'sale',
                    'refund',
                    'chargeback',
                    'chargeback_reversal',
                    'chargeback_fee',
                    'reserve_hold',
                    'reserve_release',
                    'hold',
                    'hold_release',
                    'adjustment',
                    'payout',
                    'payout_reversal',
                    'payout_fee',
                    'payout_return_fee',
                ],
            },
            source_id: {
                array: true,
                values: null,
                description:
                    'an order, charge, refund, dispute, hold, adjustment or payout public id the row belongs to',
            },
            payout_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'an id contains',
            },
        },
        export: {
            path: '/staff/reports/balance-transactions/export',
            columns: [
                'id',
                'occurred_at',
                'available_on',
                'available_at',
                'category',
                'gross_cents',
                'tax_cents',
                'fee_cents',
                'reserve_cents',
                'net_cents',
                'currency',
                'source_type',
                'source_id',
                'order_id',
                'charge_id',
                'entry_id',
                'payout_id',
                'statement_id',
                'memo',
                'merchant_id',
            ],
        },
    },
    '/staff/reports/charges': {
        path: '/staff/reports/charges',
        sorts: [
            'occurred_at',
            'amount_cents',
            'state',
            'captured_at',
            'settled_at',
            'merchant_id',
            'decline_code',
            'decline_category',
        ],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            state: {
                array: true,
                values: ['approved', 'declined', 'settled'],
            },
            order_id: {
                array: true,
                values: null,
            },
            subscription_id: {
                array: true,
                values: null,
            },
            decline_category: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, order id or card last 4 contains',
            },
        },
        export: null,
    },
    '/staff/reports/disputes': {
        path: '/staff/reports/disputes',
        sorts: [
            'opened_at',
            'amount_cents',
            'fee_cents',
            'status',
            'evidence_due_at',
            'closed_at',
            'merchant_id',
            'source',
            'reason_code',
        ],
        defaultSort: '-opened_at',
        date: 'opened_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            status: {
                array: true,
                values: [
                    'open',
                    'evidence_submitted',
                    'won',
                    'lost',
                    'accepted',
                    'expired',
                ],
            },
            source: {
                array: true,
                values: null,
            },
            charge_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, charge id, order id or reason code contains',
            },
        },
        export: null,
    },
    '/staff/reports/merchants': {
        path: '/staff/reports/merchants',
        sorts: [
            'created_at',
            'display_name',
            'legal_name',
            'status',
            'kyc_status',
            'orders_30d',
            'paid_cents_30d',
            'refunds_30d',
            'disputes_30d',
            'approved_at',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            status: {
                array: true,
                values: ['draft', 'pending', 'approved', 'suspended', 'closed'],
            },
            kyc_status: {
                array: true,
                values: [
                    'not_started',
                    'in_progress',
                    'submitted',
                    'verified',
                    'rejected',
                ],
            },
            q: {
                array: false,
                values: null,
                description:
                    'id, legal name, display name or descriptor contains',
            },
        },
        export: null,
    },
    '/staff/reports/orders': {
        path: '/staff/reports/orders',
        sorts: [
            'captured_at',
            'total_cents',
            'subtotal_cents',
            'tax_cents',
            'refunded_cents',
            'fee_cents',
            'status',
            'buyer_email',
            'merchant_id',
            'fulfilled_at',
            'line_count',
            'source',
        ],
        defaultSort: '-captured_at',
        date: 'captured_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            status: {
                array: true,
                values: [
                    'paid',
                    'fulfilled',
                    'refunded',
                    'partially_refunded',
                    'access_revoked',
                ],
            },
            buyer_email: {
                array: true,
                values: null,
            },
            subscription_id: {
                array: true,
                values: null,
            },
            source: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, buyer email or first line name contains',
            },
        },
        export: null,
    },
    '/staff/reports/payouts': {
        path: '/staff/reports/payouts',
        sorts: ['occurred_at', 'amount_cents', 'state', 'merchant_id'],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            state: {
                array: true,
                values: ['pending', 'sent', 'settled', 'failed', 'unclaimed'],
            },
            statement_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/reports/refunds': {
        path: '/staff/reports/refunds',
        sorts: ['occurred_at', 'amount_cents', 'merchant_id', 'initiated_by'],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            charge_id: {
                array: true,
                values: null,
            },
            order_id: {
                array: true,
                values: null,
            },
            initiated_by: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, charge id or order id contains',
            },
        },
        export: null,
    },
    '/staff/reports/statements': {
        path: '/staff/reports/statements',
        sorts: [
            'period_end',
            'period_start',
            'sales_cents',
            'refunds_cents',
            'fees_cents',
            'chargebacks_cents',
            'net_cents',
            'payout_cents',
            'merchant_id',
            'occurred_at',
        ],
        defaultSort: '-period_end',
        date: 'period_end',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/reports/subscriptions': {
        path: '/staff/reports/subscriptions',
        sorts: [
            'started_at',
            'current_period_end',
            'next_charge_at',
            'trial_end',
            'amount_cents',
            'status',
            'buyer_email',
            'price_id',
            'merchant_id',
        ],
        defaultSort: '-started_at',
        date: 'started_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            status: {
                array: true,
                values: [
                    'trialing',
                    'active',
                    'past_due',
                    'paused',
                    'cancelled',
                    'ended',
                ],
            },
            price_id: {
                array: true,
                values: null,
            },
            buyer_email: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id or buyer email contains',
            },
        },
        export: null,
    },
    '/staff/reserve-policies': {
        path: '/staff/reserve-policies',
        sorts: [
            'tenant_default',
            'created_at',
            'name',
            'merchant_id',
            'pct_bps',
            'hold_days',
            'threshold_cents',
            'active_from',
            'active_to',
        ],
        defaultSort: '-tenant_default,created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'name, id or merchant id contains',
            },
            include_closed: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/reserve-schedule': {
        path: '/staff/reserve-schedule',
        sorts: ['release_at', 'reserve_cents', 'released_at'],
        defaultSort: 'release_at',
        date: 'release_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            state: {
                array: true,
                values: ['held', 'due', 'released'],
                description:
                    'held (not yet due), due (due, not released) or released',
            },
        },
        export: null,
    },
    '/staff/risk-rules': {
        path: '/staff/risk-rules',
        sorts: ['key', 'name', 'status', 'score', 'stage', 'type', 'origin'],
        defaultSort: 'key',
        date: null,
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['draft', 'shadow', 'active', 'retired'],
            },
            stage: {
                array: true,
                values: ['pre_auth', 'post_auth', 'both'],
            },
            type: {
                array: true,
                values: ['realtime', 'post_transaction'],
            },
            origin: {
                array: true,
                values: ['platform', 'tenant', 'merchant', 'store'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'key, name or condition text contains',
            },
        },
        export: null,
    },
    '/staff/risk/cases': {
        path: '/staff/risk/cases',
        sorts: [
            'sla_due_at',
            'opened_at',
            'expires_at',
            'amount_cents',
            'kind',
            'state',
            'merchant_id',
        ],
        defaultSort: 'sla_due_at',
        date: 'opened_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['open', 'approved', 'declined', 'bypassed', 'expired'],
            },
            kind: {
                array: true,
                values: ['review', 'cvv'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            assigned_to: {
                array: false,
                values: null,
                description: 'a staff user id; "none" for unassigned',
            },
            late: {
                array: false,
                values: null,
                description: 'only open cases past their SLA',
            },
            q: {
                array: false,
                values: null,
                description: 'case, charge, check or session id contains',
            },
        },
        export: null,
    },
    '/staff/risk/measures': {
        path: '/staff/risk/measures',
        sorts: ['created_at', 'applied_at', 'state', 'kind', 'merchant_id'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['proposed', 'applied', 'rejected', 'lifted'],
            },
            kind: {
                array: true,
                values: [
                    'payout_pause',
                    'capture_hold',
                    'extra_reserve',
                    'volume_cap',
                    'suspension',
                ],
            },
            merchant_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/risk/monitoring': {
        path: '/staff/risk/monitoring',
        sorts: [
            'state',
            'merchant_id',
            'computed_at',
            'chargeback_ratio_bps',
            'vamp_ratio_bps',
            'decline_ratio_bps',
        ],
        defaultSort: '-state',
        date: null,
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['ok', 'watch', 'action'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            measures: {
                array: false,
                values: null,
                description: 'only merchants with an applied measure',
            },
        },
        export: null,
    },
    '/staff/risk/screening/cases': {
        path: '/staff/risk/screening/cases',
        sorts: [
            'sla_due_at',
            'opened_at',
            'best_total',
            'state',
            'merchant_id',
        ],
        defaultSort: 'sla_due_at',
        date: 'opened_at',
        cursor: false,
        filters: {
            kind: {
                array: true,
                values: ['sanctions', 'pep'],
            },
            state: {
                array: true,
                values: ['open', 'cleared', 'confirmed'],
            },
            subject_kind: {
                array: true,
                values: ['buyer', 'owner', 'business'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            late: {
                array: false,
                values: null,
                description: 'only open cases past their deadline',
            },
        },
        export: null,
    },
    '/staff/risk/screening/subjects': {
        path: '/staff/risk/screening/subjects',
        sorts: ['last_screened_at', 'last_total', 'state', 'merchant_id'],
        defaultSort: '-last_total',
        date: null,
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['clear', 'hit', 'whitelisted'],
            },
            kind: {
                array: true,
                values: ['owner', 'business'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'merchant id or name contains',
            },
        },
        export: null,
    },
    '/staff/risk/screening/whitelist': {
        path: '/staff/risk/screening/whitelist',
        sorts: ['created_at', 'subject_kind'],
        defaultSort: '-created_at',
        date: null,
        cursor: false,
        filters: {
            subject_kind: {
                array: true,
                values: ['buyer', 'owner', 'business'],
            },
        },
        export: null,
    },
    '/staff/roles': {
        path: '/staff/roles',
        sorts: ['platform_default', 'key', 'name', 'system', 'created_at'],
        defaultSort: '-platform_default,key',
        date: null,
        cursor: false,
        filters: {
            system: {
                array: false,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'name or key contains',
            },
            audience: {
                array: false,
                values: ['staff', 'merchant'],
                description: 'staff (default) or merchant',
            },
        },
        export: null,
    },
    '/staff/sessions': {
        path: '/staff/sessions',
        sorts: [
            'created_at',
            'expires_at',
            'completed_at',
            'state',
            'mode',
            'buyer_email',
            'attempts',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'open',
                    'quoted',
                    'paying',
                    'pending',
                    'in_review',
                    'paid',
                    'declined',
                    'expired',
                    'cancelled',
                    'refused',
                    'saved',
                ],
            },
            mode: {
                array: true,
                values: ['one_off', 'plan', 'plan_change', 'setup'],
            },
            source: {
                array: true,
                values: [
                    'api',
                    'dashboard',
                    'billing',
                    'system',
                    'portal',
                    'console',
                    'renewal_auth',
                ],
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, buyer email or buyer name contains',
            },
            merchant_id: {
                array: true,
                values: null,
            },
            risk_verdict: {
                array: true,
                values: ['allow', 'review', 'decline'],
                description: "the verdict of the latest attempt's risk check",
            },
            attempts: {
                array: true,
                values: null,
                description:
                    'the number of attempts the session has spent, 0 to checkout.max_attempts',
            },
        },
        export: null,
    },
    '/staff/settlement-sources': {
        path: '/staff/settlement-sources',
        sorts: ['created_at', 'name', 'provider', 'payment_system', 'active'],
        defaultSort: 'name',
        date: 'created_at',
        cursor: false,
        filters: {
            provider: {
                array: true,
                values: null,
            },
            active: {
                array: true,
                values: ['true', 'false'],
            },
            q: {
                array: false,
                values: null,
                description: 'name, provider or account contains',
            },
        },
        export: null,
    },
    '/staff/settlements/batches': {
        path: '/staff/settlements/batches',
        sorts: [
            'uploaded_at',
            'settled_on',
            'state',
            'batch_ref',
            'rows_total',
            'rows_posted',
            'gross_cents',
            'fee_cents',
            'net_cents',
            'booked_at',
            'reconciled_at',
        ],
        defaultSort: '-uploaded_at',
        date: 'settled_on',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'uploaded',
                    'invalid',
                    'validating',
                    'validated',
                    'booking',
                    'booked',
                    'failed',
                    'reconciled',
                    'difference',
                ],
            },
            source_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id or batch reference contains',
            },
        },
        export: null,
    },
    '/staff/settlements/batches/{batch}/rows': {
        path: '/staff/settlements/batches/{batch}/rows',
        sorts: [
            'row_no',
            'kind',
            'component',
            'verdict',
            'state',
            'order_ref',
            'gross_cents',
            'fee_cents',
            'net_cents',
            'merchant_id',
        ],
        defaultSort: 'row_no',
        date: null,
        cursor: false,
        filters: {
            verdict: {
                array: true,
                values: [
                    'will_post',
                    'invalid',
                    'no_entry',
                    'amount_differs',
                    'over_refund',
                    'already_settled',
                    'no_chart',
                    'ignored',
                ],
            },
            kind: {
                array: true,
                values: ['sale', 'refund', 'chargeback', 'other'],
            },
            state: {
                array: true,
                values: ['pending', 'posted', 'ignored'],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'order reference or processor transaction id contains',
            },
        },
        export: null,
    },
    '/staff/staff': {
        path: '/staff/staff',
        sorts: [
            'name',
            'email',
            'status',
            'tenant_scope',
            'created_at',
            'last_login_at',
        ],
        defaultSort: 'name',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['invited', 'active', 'suspended', 'deactivated'],
            },
            tenant_scope: {
                array: true,
                values: ['tenant', 'platform'],
            },
            role: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'name, email or id contains',
            },
        },
        export: null,
    },
    '/staff/stores': {
        path: '/staff/stores',
        sorts: ['created_at', 'display_name', 'status', 'merchant_id'],
        defaultSort: 'status,-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'pending',
                    'approved',
                    'rejected',
                    'suspended',
                    'archived',
                ],
            },
            merchant_id: {
                array: true,
                values: null,
            },
            organization_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'store name, display name, descriptor or merchant display name contains',
            },
            pending_change: {
                array: false,
                values: null,
                description:
                    'BM-92: true = only stores with a display name change waiting for approval',
            },
        },
        export: null,
    },
    '/staff/subscriptions': {
        path: '/staff/subscriptions',
        sorts: [
            'created_at',
            'status',
            'amount_cents',
            'current_period_end',
            'next_charge_at',
            'trial_end',
            'cancelled_at',
            'buyer_email',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'trialing',
                    'active',
                    'past_due',
                    'paused',
                    'cancelled',
                ],
            },
            cancel_source: {
                array: true,
                values: [
                    'buyer',
                    'merchant_api',
                    'merchant',
                    'staff',
                    'dunning',
                    'dispute',
                    'system',
                ],
            },
            cancel_at_period_end: {
                array: false,
                values: null,
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            price_public_id: {
                array: true,
                values: null,
            },
            buyer_email: {
                array: true,
                values: null,
            },
            store_id: {
                array: true,
                values: null,
                description: 'BM-86: the store(s) the subscriptions belong to',
            },
            q: {
                array: false,
                values: null,
                description: 'id, buyer email or origin order id contains',
            },
            merchant_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/subscriptions/{subscription}/periods': {
        path: '/staff/subscriptions/{subscription}/periods',
        sorts: [
            'number',
            'period_start',
            'due_at',
            'state',
            'total_cents',
            'paid_at',
        ],
        defaultSort: 'number',
        date: 'due_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'scheduled',
                    'charging',
                    'pending',
                    'paid',
                    'declined',
                    'cancelled',
                    'skipped',
                ],
            },
        },
        export: null,
    },
    '/staff/tags': {
        path: '/staff/tags',
        sorts: ['name', 'created_at', 'usage_count'],
        defaultSort: 'name',
        date: null,
        cursor: false,
        filters: {
            q: {
                array: false,
                values: null,
                description: 'name contains (case-insensitive)',
            },
            color: {
                array: true,
                values: [
                    'slate',
                    'red',
                    'amber',
                    'green',
                    'teal',
                    'blue',
                    'violet',
                    'pink',
                ],
            },
        },
        export: null,
    },
    '/staff/tax-codes': {
        path: '/staff/tax-codes',
        sorts: ['code', 'label'],
        defaultSort: 'code',
        date: null,
        cursor: false,
        filters: {
            q: {
                array: false,
                values: null,
                description: 'code or label contains',
            },
        },
        export: null,
    },
    '/staff/tax-rate-runs': {
        path: '/staff/tax-rate-runs',
        sorts: ['created_at', 'state'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['queued', 'running', 'done', 'failed', 'stopped'],
            },
        },
        export: null,
    },
    '/staff/tax-rates': {
        path: '/staff/tax-rates',
        sorts: ['state', 'postal_code', 'tax_code', 'rate_bps', 'quoted_at'],
        defaultSort: 'state',
        date: 'quoted_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: null,
            },
            tax_code: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/tax-rates/diffs': {
        path: '/staff/tax-rates/diffs',
        sorts: ['diff_bps', 'zip', 'seed_bps', 'check_bps'],
        defaultSort: '-diff_bps',
        date: null,
        cursor: false,
        filters: {
            state: {
                array: false,
                values: null,
                description: 'the two-letter US state',
            },
            check_source: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/staff/tax/transactions': {
        path: '/staff/tax/transactions',
        sorts: [
            'created_at',
            'committed_at',
            'kind',
            'state',
            'tax_cents',
            'pre_tax_cents',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: ['pending', 'committed', 'failed', 'frozen'],
            },
            kind: {
                array: true,
                values: ['sale', 'refund', 'chargeback', 'void', 'negation'],
            },
            order_public_id: {
                array: true,
                values: null,
            },
            merchant_id: {
                array: true,
                values: null,
            },
            region: {
                array: true,
                values: null,
                description:
                    'the buyer state (two letters), the first jurisdiction of the transaction',
            },
            q: {
                array: false,
                values: null,
                description: 'id, order id or provider transaction id contains',
            },
        },
        export: null,
    },
    '/staff/tenants': {
        path: '/staff/tenants',
        sorts: ['created_at', 'updated_at', 'slug', 'status', 'name'],
        defaultSort: 'created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'draft',
                    'activating',
                    'active',
                    'suspended',
                    'closed',
                ],
            },
            q: {
                array: false,
                values: null,
                description: 'slug, id or legal name contains',
            },
        },
        export: null,
    },
    '/staff/users': {
        path: '/staff/users',
        sorts: ['created_at', 'name', 'email', 'status', 'last_login_at'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'pending_verification',
                    'invited',
                    'active',
                    'suspended',
                    'deactivated',
                ],
            },
            organization_id: {
                array: true,
                values: null,
            },
            merchant_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'email or name contains',
            },
        },
        export: null,
    },
    '/staff/vendor/ai/audit': {
        path: '/staff/vendor/ai/audit',
        sorts: [
            'created_at',
            'board',
            'surface',
            'actor_id',
            'input_tokens',
            'output_tokens',
            'cost_micros',
            'duration_ms',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            board: {
                array: true,
                values: ['tenant', 'platform', 'vendor'],
            },
            surface: {
                array: true,
                values: null,
            },
            actor_id: {
                array: true,
                values: null,
            },
            subject_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, surface, subject or actor contains',
            },
        },
        export: null,
    },
    '/staff/vendor/ai/calls': {
        path: '/staff/vendor/ai/calls',
        sorts: [
            'created_at',
            'board',
            'surface',
            'actor_id',
            'input_tokens',
            'output_tokens',
            'cost_micros',
            'duration_ms',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            board: {
                array: true,
                values: ['tenant', 'platform', 'vendor'],
            },
            surface: {
                array: true,
                values: null,
            },
            actor_id: {
                array: true,
                values: null,
            },
            subject_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, surface, subject or actor contains',
            },
        },
        export: null,
    },
    '/staff/vendor/audit': {
        path: '/staff/vendor/audit',
        sorts: ['created_at', 'action', 'entity_type'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            action: {
                array: true,
                values: null,
            },
            entity_type: {
                array: true,
                values: null,
            },
            actor_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'action or entity id contains',
            },
        },
        export: null,
    },
    '/staff/vendor/http-logs': {
        path: '/staff/vendor/http-logs',
        sorts: [
            'created_at',
            'status',
            'duration_ms',
            'client',
            'host',
            'method',
            'level',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: true,
        filters: {
            client: {
                array: true,
                values: null,
            },
            level: {
                array: true,
                values: [
                    'debug',
                    'info',
                    'notice',
                    'warning',
                    'error',
                    'critical',
                    'alert',
                    'emergency',
                ],
            },
            status: {
                array: true,
                values: null,
            },
            host: {
                array: true,
                values: null,
            },
            merchant_id: {
                array: true,
                values: null,
            },
            correlation_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'URL or correlation id contains',
            },
        },
        export: null,
    },
    '/staff/vendor/invitations': {
        path: '/staff/vendor/invitations',
        sorts: ['created_at', 'expires_at', 'email'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            q: {
                array: false,
                values: null,
                description: 'email or name contains',
            },
        },
        export: null,
    },
    '/staff/vendor/members': {
        path: '/staff/vendor/members',
        sorts: [
            'created_at',
            'updated_at',
            'email',
            'name',
            'status',
            'last_seen_at',
        ],
        defaultSort: 'created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['active', 'deactivated'],
            },
            role_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'email or name contains',
            },
        },
        export: null,
    },
    '/staff/vendor/platforms': {
        path: '/staff/vendor/platforms',
        sorts: ['slug', 'display_name', 'status', 'created_at'],
        defaultSort: 'slug',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/vendor/roles': {
        path: '/staff/vendor/roles',
        sorts: [
            'system',
            'created_at',
            'updated_at',
            'name',
            'key',
            'member_count',
            'color',
        ],
        defaultSort: '-system,created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            system: {
                array: false,
                values: null,
            },
            color: {
                array: true,
                values: [
                    'slate',
                    'red',
                    'amber',
                    'green',
                    'teal',
                    'blue',
                    'violet',
                    'pink',
                ],
            },
            q: {
                array: false,
                values: null,
                description: 'name or key contains',
            },
        },
        export: null,
    },
    '/staff/vendor/tenants': {
        path: '/staff/vendor/tenants',
        sorts: ['slug', 'display_name', 'status', 'environment', 'created_at'],
        defaultSort: 'slug',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/staff/webhook-deliveries': {
        path: '/staff/webhook-deliveries',
        sorts: [
            'created_at',
            'event_type',
            'status',
            'attempts',
            'http_status',
            'last_attempted_at',
            'next_attempt_at',
            'delivered_at',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            subject: {
                array: true,
                values: null,
                description:
                    '<subject_type>:<subject_id>, 1 to 100 pairs; subject_type one of order, charge, refund, subscription, dispute, payment_method, payout, checkout',
            },
            status: {
                array: true,
                values: ['pending', 'sending', 'succeeded', 'failed', 'dead'],
            },
            event_type: {
                array: true,
                values: null,
            },
            http_status: {
                array: true,
                values: null,
            },
            replay: {
                array: false,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'event id or delivery id contains',
            },
        },
        export: null,
    },
    '/staff/webhook-endpoints': {
        path: '/staff/webhook-endpoints',
        sorts: [
            'created_at',
            'url',
            'description',
            'consecutive_failures',
            'disabled_at',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            disabled: {
                array: false,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'url, description or id contains',
            },
        },
        export: null,
    },
    '/staff/webhook-endpoints/{endpoint}/deliveries': {
        path: '/staff/webhook-endpoints/{endpoint}/deliveries',
        sorts: [
            'created_at',
            'event_type',
            'status',
            'attempts',
            'http_status',
            'last_attempted_at',
            'next_attempt_at',
            'delivered_at',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['pending', 'sending', 'succeeded', 'failed', 'dead'],
            },
            event_type: {
                array: true,
                values: null,
            },
            http_status: {
                array: true,
                values: null,
            },
            replay: {
                array: false,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'event id or delivery id contains',
            },
        },
        export: null,
    },
    '/v1/adjustments': {
        path: '/v1/adjustments',
        sorts: [
            'created_at',
            'decided_at',
            'amount_cents',
            'state',
            'direction',
            'merchant_id',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/v1/ap': {
        path: '/v1/ap',
        sorts: ['display_name', 'id', 'status', 'timezone'],
        defaultSort: 'display_name',
        date: null,
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            status: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/v1/api-keys': {
        path: '/v1/api-keys',
        sorts: ['created_at', 'name', 'last_used_at'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            revoked: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/v1/approvals': {
        path: '/v1/approvals',
        sorts: [
            'created_at',
            'expires_at',
            'decided_at',
            'state',
            'action',
            'merchant_id',
            'requested_by',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: null,
            },
            action: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/v1/bank-accounts': {
        path: '/v1/bank-accounts',
        sorts: ['created_at', 'name', 'type', 'status', 'bank_name'],
        defaultSort: 'name',
        date: 'created_at',
        cursor: false,
        filters: {
            type: {
                array: true,
                values: null,
            },
            status: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/v1/charges': {
        path: '/v1/charges',
        sorts: [
            'created_at',
            'captured_at',
            'settled_at',
            'amount_cents',
            'refunded_cents',
            'state',
            'cof_intent',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'pending',
                    'authorized',
                    'in_review',
                    'approved',
                    'declined',
                    'unknown',
                    'voided',
                    'refunded',
                    'partially_refunded',
                    'duplicate',
                    'invalid',
                    'error',
                ],
            },
            cof_intent: {
                array: true,
                values: [
                    'one_off',
                    'one_off_store',
                    'sub_initial',
                    'trial_initial',
                    'card_update_cit',
                    'renewal_mit',
                    'buyer_cit_on_file',
                    'unscheduled_mit',
                ],
            },
            order_public_id: {
                array: true,
                values: null,
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            subscription_public_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'id, order id, buyer email or card last 4 contains',
            },
            customer_ref: {
                array: false,
                values: null,
                description:
                    "exact match on the merchant's customer reference; charges made before BM-35 rev 5 hold none (BM-35 § 60)",
            },
            customer_id: {
                array: false,
                values: null,
                description:
                    "exact match on the customer's cus_ id; charges of a session without a customer hold none (BM-112 § 3)",
            },
        },
        export: null,
    },
    '/v1/customers': {
        path: '/v1/customers',
        sorts: [
            'last_order_at',
            'created_at',
            'first_order_at',
            'orders_count',
            'refunded_cents',
            'customer_ref',
        ],
        defaultSort: '-last_order_at,-created_at',
        date: null,
        cursor: false,
        filters: {
            customer_ref: {
                array: false,
                values: null,
                description: "exact match on the merchant's customer reference",
            },
            customer_id: {
                array: false,
                values: null,
                description:
                    "exact match on the customer's cus_ id (BM-112 § 3)",
            },
            buyer_email: {
                array: false,
                values: null,
                description:
                    'a customer any of whose orders has this email, or a customer with no order whose own email it is; exact match on the lowercased input',
            },
        },
        export: null,
    },
    '/v1/disputes': {
        path: '/v1/disputes',
        sorts: [
            'opened_at',
            'evidence_due_at',
            'closed_at',
            'amount_cents',
            'fee_cents',
            'status',
            'source',
            'reason_code',
            'merchant_id',
        ],
        defaultSort: '-opened_at',
        date: 'opened_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'open',
                    'evidence_submitted',
                    'won',
                    'lost',
                    'accepted',
                    'expired',
                ],
            },
            source: {
                array: true,
                values: ['chargeback'],
            },
            q: {
                array: false,
                values: null,
                description:
                    'dispute, charge or order id, or reason code contains',
            },
        },
        export: null,
    },
    '/v1/entries': {
        path: '/v1/entries',
        sorts: [
            'posted_at',
            'entry_type',
            'captured_at',
            'release_at',
            'order_id',
            'charge_id',
            'posted_by',
        ],
        defaultSort: '-posted_at',
        date: 'posted_at',
        cursor: true,
        filters: {
            sub_account: {
                array: false,
                values: null,
            },
            entry_type: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/v1/exports': {
        path: '/v1/exports',
        sorts: ['created_at', 'status', 'kind'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/v1/holds': {
        path: '/v1/holds',
        sorts: [
            'placed_at',
            'released_at',
            'amount_cents',
            'merchant_id',
            'source',
        ],
        defaultSort: '-placed_at',
        date: 'placed_at',
        cursor: false,
        filters: {
            include_released: {
                array: false,
                values: null,
            },
            source: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/v1/orders': {
        path: '/v1/orders',
        sorts: [
            'created_at',
            'captured_at',
            'total_cents',
            'subtotal_cents',
            'refunded_cents',
            'status',
            'buyer_email',
            'buyer_name',
            'source',
            'fulfilled_at',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'paid',
                    'fulfilled',
                    'refunded',
                    'partially_refunded',
                    'access_revoked',
                ],
            },
            source: {
                array: true,
                values: ['hosted', 'server', 'renewal', 'console'],
            },
            subscription_public_id: {
                array: true,
                values: null,
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            buyer_email: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description:
                    'id, buyer email, buyer name or charge id contains',
            },
            customer_ref: {
                array: false,
                values: null,
                description:
                    "exact match on the merchant's customer reference; orders of sessions without one hold none (BM-35 § 59)",
            },
            customer_id: {
                array: false,
                values: null,
                description:
                    "exact match on the customer's cus_ id; orders of sessions without a customer hold none (BM-112 § 3)",
            },
            reference: {
                array: false,
                values: null,
                description:
                    "exact match on the merchant's own order reference; not unique, so several orders may match (BM-35 § 64)",
            },
        },
        export: null,
    },
    '/v1/payment-methods': {
        path: '/v1/payment-methods',
        sorts: ['created_at', 'brand', 'last4', 'exp_year'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            customer_id: {
                array: false,
                values: null,
                description:
                    "the cus_ id of the customer whose cards are listed; customer_id or customer_ref is required: with neither, 422 missing_customer_ref, so no call lists every customer's cards (BM-35 D-79, BM-112 D-19)",
            },
            customer_ref: {
                array: false,
                values: null,
                description:
                    "the merchant's customer reference whose cards are listed; customer_id or customer_ref is required: with neither, 422 missing_customer_ref (BM-35 D-79, BM-112 D-19)",
            },
            brand: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, last 4 or buyer email contains',
            },
        },
        export: null,
    },
    '/v1/payout-runs': {
        path: '/v1/payout-runs',
        sorts: [
            'created_at',
            'period_start',
            'period_end',
            'state',
            'total_cents',
            'executed_at',
            'requested_by',
            'payout_count',
        ],
        defaultSort: '-created_at',
        date: 'period_start',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/v1/periods': {
        path: '/v1/periods',
        sorts: ['period_start', 'kind', 'status', 'entries_count', 'closed_at'],
        defaultSort: '-period_start',
        date: 'period_start',
        cursor: true,
        filters: {
            kind: {
                array: true,
                values: ['day', 'month'],
            },
            status: {
                array: true,
                values: ['closed', 'integrity_failed'],
            },
        },
        export: null,
    },
    '/v1/prices': {
        path: '/v1/prices',
        sorts: [
            'created_at',
            'price_version',
            'amount_cents',
            'active_from',
            'active_to',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            product_id: {
                array: true,
                values: null,
            },
            active: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/v1/products': {
        path: '/v1/products',
        sorts: ['created_at', 'updated_at', 'name', 'status', 'tax_code'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['active', 'archived'],
            },
            id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'name, description or id contains',
            },
        },
        export: null,
    },
    '/v1/refunds': {
        path: '/v1/refunds',
        sorts: ['created_at', 'issued_at', 'amount_cents', 'state', 'source'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'pending_approval',
                    'rejected',
                    'sending',
                    'issued',
                    'failed',
                    'unknown',
                ],
            },
            source: {
                array: true,
                values: ['api', 'dashboard', 'staff', 'system'],
            },
            charge_id: {
                array: true,
                values: null,
                description:
                    'refunds of these charges (chg_ ids), the name webhooks deliver (BM-112 D-36)',
            },
            charge_public_id: {
                array: true,
                values: null,
                description:
                    'Older name of charge_id[]. Still read; a request that sends it still succeeds (BM-112 D-36).',
            },
            q: {
                array: false,
                values: null,
                description: 'id or reason contains',
            },
        },
        export: null,
    },
    '/v1/reports/balance-transactions': {
        path: '/v1/reports/balance-transactions',
        sorts: [
            'occurred_at',
            'available_on',
            'available_at',
            'gross_cents',
            'net_cents',
            'category',
            'merchant_id',
        ],
        defaultSort: '-occurred_at',
        date: 'occurred_at',
        cursor: false,
        filters: {
            category: {
                array: true,
                values: [
                    'sale',
                    'refund',
                    'chargeback',
                    'chargeback_reversal',
                    'chargeback_fee',
                    'reserve_hold',
                    'reserve_release',
                    'hold',
                    'hold_release',
                    'adjustment',
                    'payout',
                    'payout_reversal',
                    'payout_fee',
                    'payout_return_fee',
                ],
            },
            source_id: {
                array: true,
                values: null,
                description:
                    'an order, charge, refund, dispute, hold, adjustment or payout public id the row belongs to',
            },
            payout_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'an id contains',
            },
        },
        export: {
            path: '/v1/reports/balance-transactions/export',
            columns: [
                'id',
                'occurred_at',
                'available_on',
                'available_at',
                'category',
                'gross_cents',
                'tax_cents',
                'fee_cents',
                'reserve_cents',
                'net_cents',
                'currency',
                'source_type',
                'source_id',
                'order_id',
                'charge_id',
                'entry_id',
                'payout_id',
                'statement_id',
                'memo',
                'merchant_id',
            ],
        },
    },
    '/v1/settlement-sources': {
        path: '/v1/settlement-sources',
        sorts: ['created_at', 'name', 'provider', 'payment_system', 'active'],
        defaultSort: 'name',
        date: 'created_at',
        cursor: false,
        filters: {
            active: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/v1/settlements/batches': {
        path: '/v1/settlements/batches',
        sorts: [
            'uploaded_at',
            'settled_on',
            'state',
            'batch_ref',
            'rows_total',
            'rows_posted',
            'gross_cents',
            'fee_cents',
            'net_cents',
            'booked_at',
            'reconciled_at',
        ],
        defaultSort: '-uploaded_at',
        date: 'settled_on',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: null,
            },
            source_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/v1/settlements/batches/{batch}/rows': {
        path: '/v1/settlements/batches/{batch}/rows',
        sorts: [
            'row_no',
            'kind',
            'component',
            'verdict',
            'state',
            'order_ref',
            'gross_cents',
            'fee_cents',
            'net_cents',
            'merchant_id',
        ],
        defaultSort: 'row_no',
        date: null,
        cursor: false,
        filters: {
            verdict: {
                array: true,
                values: null,
            },
            kind: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
    '/v1/statements': {
        path: '/v1/statements',
        sorts: [
            'period_start',
            'period_end',
            'issued_at',
            'merchant_id',
            'net_cents',
            'payout_cents',
            'sales_cents',
            'closing_cents',
            'state',
        ],
        defaultSort: '-period_start',
        date: 'period_start',
        cursor: false,
        filters: {
            merchant_id: {
                array: true,
                values: null,
            },
            period: {
                array: true,
                values: null,
            },
            state: {
                array: true,
                values: [
                    'issued',
                    'carried_forward',
                    'paid',
                    'not_paid',
                    'offset',
                ],
            },
        },
        export: null,
    },
    '/v1/statements/{statement}/lines': {
        path: '/v1/statements/{statement}/lines',
        sorts: ['posted_at', 'amount_cents', 'line_type', 'occurred_at'],
        defaultSort: 'posted_at',
        date: null,
        cursor: false,
        filters: {
            line_type: {
                array: true,
                values: null,
            },
            direction: {
                array: true,
                values: ['credit', 'debit'],
            },
            record_id: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'entry key, record, order or charge id contains',
            },
        },
        export: null,
    },
    '/v1/sub-accounts': {
        path: '/v1/sub-accounts',
        sorts: ['display_name', 'id', 'status', 'timezone'],
        defaultSort: 'display_name',
        date: null,
        cursor: false,
        filters: {
            status: {
                array: true,
                values: null,
            },
            external_ref: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
            },
        },
        export: null,
    },
    '/v1/subscriptions': {
        path: '/v1/subscriptions',
        sorts: [
            'created_at',
            'status',
            'amount_cents',
            'current_period_end',
            'next_charge_at',
            'trial_end',
            'cancelled_at',
            'buyer_email',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: [
                    'trialing',
                    'active',
                    'past_due',
                    'paused',
                    'cancelled',
                ],
            },
            cancel_source: {
                array: true,
                values: [
                    'buyer',
                    'merchant_api',
                    'merchant',
                    'staff',
                    'dunning',
                    'dispute',
                    'system',
                ],
            },
            cancel_at_period_end: {
                array: false,
                values: null,
            },
            buyer_public_id: {
                array: true,
                values: null,
            },
            price_public_id: {
                array: true,
                values: null,
            },
            buyer_email: {
                array: true,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'id, buyer email or origin order id contains',
            },
            customer_ref: {
                array: false,
                values: null,
                description:
                    "exact match on the merchant's customer reference; subscriptions started before it was carried hold none (BM-35 § 61)",
            },
            customer_id: {
                array: false,
                values: null,
                description:
                    "exact match on the customer's cus_ id; subscriptions of an order without a customer hold none (BM-112 § 3)",
            },
        },
        export: null,
    },
    '/v1/subscriptions/{subscription}/periods': {
        path: '/v1/subscriptions/{subscription}/periods',
        sorts: [
            'number',
            'period_start',
            'due_at',
            'state',
            'total_cents',
            'paid_at',
        ],
        defaultSort: 'number',
        date: 'due_at',
        cursor: false,
        filters: {
            state: {
                array: true,
                values: [
                    'scheduled',
                    'charging',
                    'pending',
                    'paid',
                    'declined',
                    'cancelled',
                    'skipped',
                ],
            },
        },
        export: null,
    },
    '/v1/users': {
        path: '/v1/users',
        sorts: [
            'created_at',
            'name',
            'email',
            'status',
            'role',
            'last_login_at',
        ],
        defaultSort: 'created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['invited', 'active', 'suspended', 'deactivated'],
            },
            role: {
                array: true,
                values: [
                    'owner',
                    'admin',
                    'finance',
                    'developer',
                    'support',
                    'viewer',
                ],
            },
            q: {
                array: false,
                values: null,
                description: 'name or email contains',
            },
        },
        export: null,
    },
    '/v1/webhook-endpoints': {
        path: '/v1/webhook-endpoints',
        sorts: [
            'created_at',
            'url',
            'description',
            'consecutive_failures',
            'disabled_at',
        ],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            disabled: {
                array: false,
                values: null,
            },
            q: {
                array: false,
                values: null,
                description: 'url, description or id contains',
            },
        },
        export: null,
    },
    '/v1/webhook-endpoints/{endpoint}/deliveries': {
        path: '/v1/webhook-endpoints/{endpoint}/deliveries',
        sorts: ['created_at', 'status', 'event_type', 'attempts'],
        defaultSort: '-created_at',
        date: 'created_at',
        cursor: false,
        filters: {
            status: {
                array: true,
                values: ['pending', 'succeeded', 'failed', 'dead'],
            },
            event_type: {
                array: true,
                values: null,
            },
            event_id: {
                array: true,
                values: null,
            },
        },
        export: null,
    },
} as const;

export type ListPath = keyof typeof LISTS;
